import { render } from "./ModalUserProfileDelete.vue?vue&type=template&id=2a37ae3a"
import script from "./ModalUserProfileDelete.vue?vue&type=script&lang=js"
export * from "./ModalUserProfileDelete.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__